import { HeroSection } from "../components/sections/HeroSection";
import { InfiniteSlider } from "../components/sections/InfiniteSlider";
import { ValueProposition } from "../components/sections/ValueProposition";
import { ServicesOverview } from "../components/sections/ServicesOverview";
import { HowItWorks } from "../components/sections/HowItWorks";
import { USPSection } from "../components/sections/USPSection";
import { TrustSection } from "../components/sections/TrustSection";
import { TestimonialsSection } from "../components/sections/TestimonialsSection";
import { ArticlesSection } from "../components/sections/ArticlesSection";
import { LeadForm } from "../components/sections/LeadForm";
import { SEO } from "../components/common/SEO";
import { SEO_DATA } from "../data/seoData";
import { motion } from "framer-motion";

export default function HomePage({ onOpenAppointment }) {
  return (
    <div>
      <SEO 
        title={SEO_DATA.home.title}
        description={SEO_DATA.home.description}
        keywords={SEO_DATA.home.keywords}
        canonical="https://switchyourvendor.com/"
      />
      <HeroSection onOpenAppointment={onOpenAppointment} />
      <InfiniteSlider />
      <ServicesOverview />
      <ValueProposition />
      <HowItWorks />
      <USPSection />
      <TrustSection />
      <TestimonialsSection />
      <ArticlesSection />

      {/* Contact / Lead Form Section */}
      <section id="contact" data-testid="contact-section" className="py-16 md:py-20 bg-white">
        <div className="max-w-2xl mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-10"
          >
            <span className="text-red-600 font-bold text-xs tracking-[0.2em] uppercase font-body">
              Let's Talk
            </span>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-[44px] font-black mt-3 mb-3 tracking-tight">
              Get Started Today
            </h2>
            <p className="text-slate-500 text-base md:text-lg font-body">
              Fill out the form — we'll respond within 24 hours
            </p>
          </motion.div>
          <LeadForm />
        </div>
      </section>
    </div>
  );
}
